import React, { useState, useEffect, useCallback } from 'react';
import api from '../utils/api';

function CourtApplicationData({ clientId, clientType, onFieldsSaved }) {
  const [workplace, setWorkplace] = useState('');
  const [salary, setSalary] = useState('');
  const [maritalStatus, setMaritalStatus] = useState('not_married');
  const [transactions3y, setTransactions3y] = useState('отсутствуют');
  const [debtPurpose, setDebtPurpose] = useState('для личных и бытовых нужд');
  const [dependents, setDependents] = useState([]);
  const [property, setProperty] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [newDep, setNewDep] = useState({ full_name: '', birth_date: '', relation: '', notes: '' });
  const [newProp, setNewProp] = useState({ property_type: '', description: '', basis_documents: '', address: '', ownership_type: '', area: '', pledge_info: 'отсутствуют', vin: '', cost: '' });
  const [newAtt, setNewAtt] = useState('');
  const [bankAccounts, setBankAccounts] = useState([]);
  const [newBank, setNewBank] = useState({ bank_name: '', bank_address: '', currency: 'руб.', open_date: '', balance: '0' });
  const [creditorDb, setCreditorDb] = useState([]);
  const [bankSuggestions, setBankSuggestions] = useState([]);
  const [lastDeleted, setLastDeleted] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data: cl } = await api.get(`/clients/${clientId}`);
      setWorkplace(cl.workplace || '');
      setSalary(cl.salary || '');
      setMaritalStatus(cl.marital_status || 'not_married');
      setTransactions3y(cl.transactions_3y || 'отсутствуют');
      setDebtPurpose(cl.debt_purpose || 'для личных и бытовых нужд');
    } catch (e) { console.error(e); }
    try { const { data } = await api.get(`/client-dependents/${clientId}`); setDependents(data); } catch(e){}
    try { const { data } = await api.get(`/client-property/${clientId}`); setProperty(data); } catch(e){}
    try { const { data } = await api.get(`/client-attachments/${clientId}`); setAttachments(data); } catch(e){}
    try { const { data } = await api.get(`/client-bank-accounts/${clientId}`); setBankAccounts(data); } catch(e){}
    try { const { data } = await api.get('/creditor-db'); setCreditorDb(data); } catch(e){}
  }, [clientId]);

  useEffect(() => { if (clientType === 'court') load(); }, [clientType, load]);

  if (clientType !== 'court') return null;

  const addBank = async () => {
    if (!newBank.bank_name) return;
    await api.post('/client-bank-accounts', { client_id: clientId, ...newBank });
    setNewBank({ bank_name: '', bank_address: '', currency: 'руб.', open_date: '', balance: '0' });
    const { data } = await api.get(`/client-bank-accounts/${clientId}`); setBankAccounts(data);
  };
  const delBank = async (id) => {
    await api.delete(`/client-bank-accounts/${id}`);
    const { data } = await api.get(`/client-bank-accounts/${clientId}`); setBankAccounts(data);
  };

  const saveFields = async () => {
    setSaving(true);
    try {
      await api.put(`/clients/${clientId}/court-fields`, { workplace, salary: salary || null, marital_status: maritalStatus, transactions_3y: transactions3y, debt_purpose: debtPurpose });
      if (onFieldsSaved) onFieldsSaved();
    } catch (e) { console.error(e); }
    setSaving(false);
  };

  const addDep = async () => {
    if (!newDep.full_name) return;
    await api.post('/client-dependents', { client_id: clientId, ...newDep });
    setNewDep({ full_name: '', birth_date: '', relation: '', notes: '' });
    const { data } = await api.get(`/client-dependents/${clientId}`); setDependents(data);
  };
  const delDep = async (id) => {
    const deleted = dependents.find(d => d.id === id);
    await api.delete(`/client-dependents/${id}`);
    const { data } = await api.get(`/client-dependents/${clientId}`);
    setDependents(data);
    if (deleted) setLastDeleted({ type: 'dependent', data: deleted });
  };

  const addProp = async () => {
    if (!newProp.description) return;
    await api.post('/client-property', { client_id: clientId, ...newProp });
    setNewProp({ property_type: '', description: '', basis_documents: '', address: '', ownership_type: '', area: '', pledge_info: 'отсутствуют', vin: '', cost: '' });
    const { data } = await api.get(`/client-property/${clientId}`); setProperty(data);
  };
  const delProp = async (id) => {
    const deleted = property.find(p => p.id === id);
    await api.delete(`/client-property/${id}`);
    const { data } = await api.get(`/client-property/${clientId}`);
    setProperty(data);
    if (deleted) setLastDeleted({ type: 'property', data: deleted });
  };

  const addAtt = async () => {
    if (!newAtt.trim()) return;
    await api.post('/client-attachments', { client_id: clientId, sort_order: attachments.length + 1, description: newAtt });
    setNewAtt('');
    const { data } = await api.get(`/client-attachments/${clientId}`); setAttachments(data);
  };
  const delAtt = async (id) => {
    const deleted = attachments.find(a => a.id === id);
    await api.delete(`/client-attachments/${id}`);
    const { data } = await api.get(`/client-attachments/${clientId}`);
    setAttachments(data);
    if (deleted) setLastDeleted({ type: 'attachment', data: deleted });
  };

  const undoDelete = async () => {
    if (!lastDeleted) return;
    try {
      if (lastDeleted.type === 'attachment') {
        await api.post('/client-attachments', { client_id: clientId, sort_order: lastDeleted.data.sort_order, description: lastDeleted.data.description });
        const { data } = await api.get(`/client-attachments/${clientId}`); setAttachments(data);
      } else if (lastDeleted.type === 'dependent') {
        await api.post('/client-dependents', { client_id: clientId, full_name: lastDeleted.data.full_name, birth_date: lastDeleted.data.birth_date, relation: lastDeleted.data.relation, notes: lastDeleted.data.notes });
        const { data } = await api.get(`/client-dependents/${clientId}`); setDependents(data);
      } else if (lastDeleted.type === 'property') {
        await api.post('/client-property', { client_id: clientId, property_type: lastDeleted.data.property_type, description: lastDeleted.data.description, basis_documents: lastDeleted.data.basis_documents, address: lastDeleted.data.address, ownership_type: lastDeleted.data.ownership_type, area: lastDeleted.data.area, pledge_info: lastDeleted.data.pledge_info, vin: lastDeleted.data.vin, cost: lastDeleted.data.cost });
        const { data } = await api.get(`/client-property/${clientId}`); setProperty(data);
      }
      setLastDeleted(null);
    } catch(e) { console.error(e); }
  };

  React.useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.key === 'я' || e.code === 'KeyZ')) {
        e.preventDefault();
        undoDelete();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  });

  const generateAtts = async () => {
    if (attachments.length > 0 && !window.confirm('Текущий список будет заменён. Продолжить?')) return;
    try {
      const { data } = await api.post(`/generate-attachments/${clientId}`);
      setAttachments(data);
    } catch (e) { console.error(e); }
  };

  const sec = { background: 'var(--bg-surface)', borderRadius: 8, padding: 16, marginBottom: 12, border: '1px solid var(--border-color)' };
  const lab = { fontWeight: 600, fontSize: 13, marginBottom: 4, display: 'block', color: 'var(--text-secondary)' };
  const item = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 10px', background: 'var(--bg-main)', borderRadius: 4, marginBottom: 4, border: '1px solid var(--border-color)', fontSize: 13 };

  return (
    <div style={{ marginTop: 20 }}>
      <h3 style={{ borderBottom: '2px solid var(--color-primary)', paddingBottom: 8, marginBottom: 16, fontSize: 16 }}>Данные для заявления на банкротство</h3>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Работа и доход</h4>
        <label style={lab}>Место работы</label>
        <input className="form-input" value={workplace} onChange={e => setWorkplace(e.target.value)} placeholder='АО "Белорецкий Металлургический Комбинат"' />
        <label style={{...lab, marginTop: 8}}>Заработная плата (руб.)</label>
        <input className="form-input" type="number" value={salary} onChange={e => setSalary(e.target.value)} placeholder="33000" />
      </div>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Семейное положение</h4>
        <select className="form-select" value={maritalStatus} onChange={e => setMaritalStatus(e.target.value)}>
          <option value="not_married">Не состоит в браке</option>
          <option value="married">В браке</option>
          <option value="divorced">Брак расторгнут</option>
          <option value="widowed">Вдова/Вдовец</option>
        </select>
      </div>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Иждивенцы</h4>
        {dependents.map(d => (
          <div key={d.id} style={item}>
            <span>{d.full_name} {d.birth_date ? `(${new Date(d.birth_date).toLocaleDateString('ru')})` : ''} {d.relation ? `— ${d.relation}` : ''} {d.notes || ''}</span>
            <button className="btn btn-danger btn-sm" onClick={() => delDep(d.id)} style={{padding:'2px 8px',fontSize:11}}>✕</button>
          </div>
        ))}
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
          <input className="form-input" style={{flex:2,minWidth:180}} placeholder="ФИО" value={newDep.full_name} onChange={e => setNewDep({...newDep, full_name: e.target.value})} />
          <input className="form-input" style={{flex:1,minWidth:120}} type="date" value={newDep.birth_date} onChange={e => setNewDep({...newDep, birth_date: e.target.value})} />
          <input className="form-input" style={{flex:1,minWidth:90}} placeholder="сын/дочь" value={newDep.relation} onChange={e => setNewDep({...newDep, relation: e.target.value})} />
          <input className="form-input" style={{flex:2,minWidth:180}} placeholder="Примечание" value={newDep.notes} onChange={e => setNewDep({...newDep, notes: e.target.value})} />
          <button className="btn btn-primary btn-sm" onClick={addDep}>+ Добавить</button>
        </div>
      </div>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Имущество</h4>
        {property.map(p => (
          <div key={p.id} style={item}>
            <div style={{flex:1}}>
              <div><strong>{p.description}</strong>{p.area ? ` — ${p.area} кв.м.` : ''}</div>
              {p.address && <div style={{fontSize:11,color:'var(--text-muted)'}}>Адрес: {p.address}</div>}
              {p.ownership_type && <div style={{fontSize:11,color:'var(--text-muted)'}}>Собственность: {p.ownership_type}</div>}
              {p.basis_documents && <div style={{fontSize:11,color:'var(--text-muted)'}}>Основание: {p.basis_documents}</div>}
              {p.cost && <div style={{fontSize:11,color:'var(--text-muted)'}}>Стоимость: {p.cost}</div>}
              {p.vin && <div style={{fontSize:11,color:'var(--text-muted)'}}>VIN: {p.vin}</div>}
              {p.pledge_info && p.pledge_info !== 'отсутствуют' && <div style={{fontSize:11,color:'var(--text-muted)'}}>Залог: {p.pledge_info}</div>}
            </div>
            <button className="btn btn-danger btn-sm" onClick={() => delProp(p.id)} style={{padding:'2px 8px',fontSize:11}}>✕</button>
          </div>
        ))}
        <div style={{display:'flex',flexDirection:'column',gap:4,marginTop:6}}>
          <select className="form-select" value={newProp.property_type} onChange={e => setNewProp({...newProp, property_type: e.target.value})}>
            <option value="">Тип имущества</option>
            <option value="apartment">Квартира/доля</option>
            <option value="house">Дом</option>
            <option value="land">Земельный участок</option>
            <option value="garage">Гараж</option>
            <option value="vehicle">Транспорт</option>
            <option value="other_realty">Иное недвижимое</option>
            <option value="other">Иное имущество</option>
          </select>
          <input className="form-input" placeholder="Описание (½ доли в 3х комнатной квартире)" value={newProp.description} onChange={e => setNewProp({...newProp, description: e.target.value})} />
          <input className="form-input" placeholder="Адрес / Местонахождение" value={newProp.address} onChange={e => setNewProp({...newProp, address: e.target.value})} />
          <div style={{display:'flex',gap:4}}>
            <input className="form-input" style={{flex:1}} placeholder="Вид собственности (долевая, индивидуальная)" value={newProp.ownership_type} onChange={e => setNewProp({...newProp, ownership_type: e.target.value})} />
            <input className="form-input" style={{flex:1}} placeholder="Площадь кв.м." value={newProp.area} onChange={e => setNewProp({...newProp, area: e.target.value})} />
          </div>
          <div style={{display:'flex',gap:4}}>
            <input className="form-input" style={{flex:1}} placeholder="Стоимость" value={newProp.cost} onChange={e => setNewProp({...newProp, cost: e.target.value})} />
            <input className="form-input" style={{flex:1}} placeholder="VIN / идентификатор (для транспорта)" value={newProp.vin} onChange={e => setNewProp({...newProp, vin: e.target.value})} />
          </div>
          <input className="form-input" placeholder="Основание приобретения (договор, свидетельство)" value={newProp.basis_documents} onChange={e => setNewProp({...newProp, basis_documents: e.target.value})} />
          <input className="form-input" placeholder="Сведения о залоге (по умолчанию: отсутствуют)" value={newProp.pledge_info} onChange={e => setNewProp({...newProp, pledge_info: e.target.value})} />
          <button className="btn btn-primary btn-sm" onClick={addProp}>+ Добавить имущество</button>
        </div>
      </div>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Банковские счета</h4>
        {bankAccounts.map(b => (
          <div key={b.id} style={item}>
            <div style={{flex:1}}>
              <div><strong>{b.bank_name}</strong></div>
              {b.bank_address && <div style={{fontSize:11,color:'var(--text-muted)'}}>{b.bank_address}</div>}
              <div style={{fontSize:11,color:'var(--text-muted)'}}>{b.currency} | Открыт: {b.open_date ? new Date(b.open_date).toLocaleDateString('ru') : '-'} | Остаток: {b.balance}</div>
            </div>
            <button className="btn btn-danger btn-sm" onClick={() => delBank(b.id)} style={{padding:'2px 8px',fontSize:11}}>✕</button>
          </div>
        ))}
        <div style={{display:'flex',flexDirection:'column',gap:4,marginTop:6}}>
          <div style={{position:'relative'}}>
            <input className="form-input" placeholder="Начните вводить название банка..." value={newBank.bank_name} onChange={e => {
              setNewBank({...newBank, bank_name: e.target.value});
              const q = e.target.value.toLowerCase();
              setBankSuggestions(q.length >= 2 ? creditorDb.filter(c => c.name.toLowerCase().includes(q)) : []);
            }} />
            {bankSuggestions.length > 0 && <div style={{position:'absolute',top:'100%',left:0,right:0,background:'var(--bg-surface)',border:'1px solid var(--border-color)',borderRadius:4,zIndex:10,maxHeight:150,overflow:'auto'}}>
              {bankSuggestions.map(s => (
                <div key={s.id} style={{padding:'6px 10px',cursor:'pointer',fontSize:13,borderBottom:'1px solid var(--border-color)'}}
                  onClick={() => { setNewBank({...newBank, bank_name: s.name, bank_address: s.address || ''}); setBankSuggestions([]); }}>
                  <strong>{s.name}</strong>{s.address ? <span style={{color:'var(--text-muted)',marginLeft:6}}>{s.address.substring(0,50)}...</span> : ''}
                </div>
              ))}
            </div>}
          </div>
          <input className="form-input" placeholder="Адрес банка" value={newBank.bank_address} onChange={e => setNewBank({...newBank, bank_address: e.target.value})} />
          <div style={{display:'flex',gap:4}}>
            <input className="form-input" style={{flex:1}} placeholder="Валюта" value={newBank.currency} onChange={e => setNewBank({...newBank, currency: e.target.value})} />
            <input className="form-input" style={{flex:1}} type="date" value={newBank.open_date} onChange={e => setNewBank({...newBank, open_date: e.target.value})} />
            <input className="form-input" style={{flex:1}} placeholder="Остаток (руб.)" value={newBank.balance} onChange={e => setNewBank({...newBank, balance: e.target.value})} />
          </div>
          <button className="btn btn-primary btn-sm" onClick={addBank}>+ Добавить счёт</button>
        </div>
      </div>

      <div style={sec}>
        <h4 style={{ margin: '0 0 12px', fontSize: 14 }}>Дополнительно</h4>
        <label style={lab}>Назначение кредитных средств</label>
        <input className="form-input" value={debtPurpose} onChange={e => setDebtPurpose(e.target.value)} />
        <label style={{...lab, marginTop: 8}}>Сделки за последние 3 года</label>
        <input className="form-input" value={transactions3y} onChange={e => setTransactions3y(e.target.value)} />
      </div>

      <div style={sec}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <h4 style={{ margin: 0, fontSize: 14 }}>Приложения к заявлению</h4>
          <button className="btn btn-secondary btn-sm" onClick={generateAtts} style={{fontSize:12}}>Сформировать автоматически</button>
        </div>
        {attachments.map((a, i) => (
          <div key={a.id} style={item}>
            <span>{i + 1}. {a.description}</span>
            <button className="btn btn-danger btn-sm" onClick={() => delAtt(a.id)} style={{padding:'2px 8px',fontSize:11}}>✕</button>
          </div>
        ))}
        <div style={{display:'flex',gap:6,marginTop:6}}>
          <input className="form-input" style={{flex:1}} placeholder="Описание приложения" value={newAtt} onChange={e => setNewAtt(e.target.value)} onKeyDown={e => e.key === 'Enter' && addAtt()} />
          <button className="btn btn-primary btn-sm" onClick={addAtt}>+ Добавить</button>
        </div>
      </div>


      <button className="btn btn-primary" onClick={saveFields} disabled={saving} style={{marginTop:12}}>
        {saving ? 'Сохранение...' : 'Сохранить данные заявления'}
      </button>
    </div>
  );
}

export default CourtApplicationData;
